import { render, staticRenderFns } from "./ui-memory-intro.vue?vue&type=template&id=1b39ae52&"
import script from "./ui-memory-intro.vue?vue&type=script&lang=js&"
export * from "./ui-memory-intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports